'use strict';

angular.module('AcaApp').controller('LoginController', [
  '$scope',
  '$rootScope',
  '$location',
  'AUTH_EVENTS',
  'AuthenticationService',
  'LOGIN_TEXT',
  'EXCEPTION',
  'MsgBetweenCtrlService',
  '$mdDialog',
  function($scope, $rootScope, $location, AUTH_EVENTS, AuthenticationService, LOGIN_TEXT, EXCEPTION, MsgBetweenCtrlService, $mdDialog){
    this.startParams = function(){
      $scope.credentials = {};
      $scope.errorMessage = '';
      $scope.showEmailRequired = false;
      $scope.showPasswordRequired = false;
    };
    if($location.search().modalMFA){
      $mdDialog.show({
        scope: $scope.$new(),
        controller: 'MFAactivationController',
        templateUrl: '/app/views/mfa/modals/mfa_activation.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
      }).finally(function(){
        $location.path('/login').search({}).replace();
      });
    }
    $scope.loginUser = function(loginUserForm){
      if(!(loginUserForm.$valid)){
        if(loginUserForm.email.$error.email){
          $scope.errorMessage = LOGIN_TEXT.INVALIDUSERPASSWORD;
        }
        $scope.eventShowEmailRequired(loginUserForm);
        $scope.eventShowPasswordRequired(loginUserForm);
      }
      else{
        $scope.errorMessage = '';
        $scope.disableButton = true;
        AuthenticationService.login($scope.credentials).then(function(data){
          if(data.result && data.result.message){
            if(data.result.message === LOGIN_TEXT.SUCCESS || data.result.message === LOGIN_TEXT.PASSWORD_EXPIRED){
              $rootScope.$emit(AUTH_EVENTS.LOGINSUCCESS, data.result);
              AuthenticationService.setUserCredentials($scope.credentials);
            }
          }
          $scope.disableButton = false;
        },
        function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          if(error.data.error.frontend_code === EXCEPTION.MAXFAILEDLOGINS ||
            error.data.error.frontend_code === EXCEPTION.ACCOUNTDISABLED){
            MsgBetweenCtrlService.data.errorMessage = error.data.error.frontend_message;
            $location.path('/account-locked');
          }
          if(error.data.error.frontend_code === EXCEPTION.CLIENTDISABLED){
            $location.path('/cliend-disabled');
          }
          else{
            $scope.errorMessage = (error.data.error.frontend_message || undefined);
          }
          $scope.disableButton = false;
        });
      }
    };
    $scope.eventShowEmailRequired = function(form){
      if(form.email.$error.required){
        $scope.showEmailRequired = true;
        $scope.errorMessage = '';
      }
      else{
        $scope.showEmailRequired = false;
      }
    };
    $scope.eventShowPasswordRequired = function(form){
      if(form.password.$error.required){
        $scope.showPasswordRequired = true;
        $scope.errorMessage = '';
      }
      else{
        $scope.showPasswordRequired = false;
      }
    };
    this.startParams();
  }
]);